import { useMutation, useQueryClient } from '@tanstack/react-query';

import {
  AssignAccountToContactPayload,
  ContactUpdateSchema,
  patchApiV5FirmsContactsId,
} from '@liscio/api';

import apiClient from 'fetch-utils/api-client';

export function useAssignAccountToContact() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      contactId,
      accountId,
    }: {
      contactId: string;
      accountId: number | string;
    }) => {
      const payload: AssignAccountToContactPayload = {
        account_id: accountId,
      };
      return await apiClient.contactsV5Firms.assignAccountToContact(
        contactId,
        payload
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['firmsContactsV5'] });
      queryClient.invalidateQueries({ queryKey: ['firmsContactsGroupedByAccount'] });
    },
  });
}

export function useUpdateFirmContact() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      contactId,
      data,
    }: {
      contactId: string;
      data: ContactUpdateSchema;
    }) => patchApiV5FirmsContactsId(contactId, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['firmsContactsV5'] });
      queryClient.invalidateQueries({ queryKey: ['firmsContactsGroupedByAccount'] });
    },
  });
}

